/* Haye Nii (task 38): small touches for the rows under Add to cart (snippets/hn-info-rows.liquid).
   1. Only one row is open at a time. Opening one closes a long one above it, so the page jumped and the row the
      shopper tapped ended up off the screen (owner: "tapped Details, saw the videos, had to scroll up").
      Now the tapped title stays right under the finger (no jump, no animation).
   2. The free-shipping icon reads on two lines like the other two ("Free shipping" / "to Canada"), also after
      assets/hn-free-shipping.js changes the country. */
(function () {
  if (window.hnProductTouch) return;
  window.hnProductTouch = true;

  // Space to keep at the top: the sticky header when it shows (it slides back in when the page moves up),
  // else a small margin
  function topGap(goingUp) {
    var header = document.querySelector('sticky-header, .section-header .header-wrapper');
    var gap = 16;
    if (header) {
      var r = header.getBoundingClientRect();
      var sticky = getComputedStyle(header.closest('.section-header') || header).position === 'sticky';
      if (r.bottom > 0 && r.top <= 1) gap = Math.max(gap, r.bottom + 12);
      else if (goingUp && sticky) gap = Math.max(gap, r.height + 12);
    }
    return gap;
  }

  function bringIntoView(row) {
    var summary = row.querySelector('summary');
    if (!summary) return;
    var r = summary.getBoundingClientRect();
    var gap = topGap(r.top < 16);
    // already comfortably on screen: leave the page where it is
    if (r.top >= gap && r.bottom <= window.innerHeight * 0.6) return;
    window.scrollTo(0, window.pageYOffset + r.top - gap);
  }

  // A row opened near the bottom of the screen: move the page up just enough to show what opened
  // (above the floating Add to cart card), never pushing its title under the top edge
  function showPanel(row, summary) {
    var h = window.innerHeight;
    var r = row.getBoundingClientRect();
    var top = summary.getBoundingClientRect().top;
    var hidden = r.bottom - (h - 100);
    if (hidden <= 0) return;
    var room = top - topGap(false);
    var by = Math.min(hidden, room);
    if (by > 4) window.scrollBy(0, by);
  }

  // Where the tapped title was on the screen just before the tap
  var tapped = null;
  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest && event.target.closest('.hn-info__row > summary, .hn-info__more > summary');
      if (summary) tapped = { summary: summary, top: summary.getBoundingClientRect().top, at: Date.now() };
    },
    true
  );

  // "toggle" does not bubble: listen in the capture phase.
  // The tapped title stays exactly where the finger is, even when a long row above it closes. Without a tap
  // (opened another way), the row is brought into view instead.
  document.addEventListener(
    'toggle',
    function (event) {
      var row = event.target;
      if (!row.matches || !row.matches('.hn-info__row, .hn-info__more')) return;
      var summary = row.querySelector('summary');
      setTimeout(function () {
        if (tapped && tapped.summary === summary && Date.now() - tapped.at < 1500) {
          var moved = summary.getBoundingClientRect().top - tapped.top;
          if (Math.abs(moved) > 2) window.scrollBy(0, moved);
          if (row.open) showPanel(row, summary);
          return;
        }
        if (row.open) bringIntoView(row);
      }, 0);
    },
    true
  );

  // Free shipping icon: "Free shipping" on line 1, "to <country>" on line 2
  function splitShip(el) {
    if (el.querySelector('.hn-info__l2')) return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    var m = /^(Free shipping) (to .+)$/.exec(text);
    if (!m) return;
    el.textContent = m[1] + ' ';
    var second = document.createElement('span');
    second.className = 'hn-info__l2';
    second.textContent = m[2];
    el.appendChild(second);
  }

  function watchShip() {
    document.querySelectorAll('.hn-info__icons [data-hn-ship]').forEach(function (el) {
      splitShip(el);
      if (!('MutationObserver' in window)) return;
      var mo = new MutationObserver(function () {
        mo.disconnect();
        splitShip(el);
        mo.observe(el, { childList: true, characterData: true, subtree: true });
      });
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchShip);
  else watchShip();
})();
